import { ISymbolConfig } from '@GFTypes/GameStoreTypes/SymbolParameters';

export const SYMBOL_CONFIGURATION_DEFAULTS: ISymbolConfig[] = [];
